
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_5308_173880)","fill":"#616161"}},[_c('path',{attrs:{"d":"M15 13.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM15 25.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM21 13.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM21 25.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM21 19.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM15 19.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_5308_173880"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h36v36H0z"}})])])])
          )
        }
      }
    